import script from "./ResetLogin.vue3.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResetLogin.vue3.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__